<script>
import { Doughnut } from "vue-chartjs";

export default {
  extends: Doughnut,
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    const headers = this.headers;
    const data = this.data;

    data.forEach((arr) => {
      for (let i = 0; i < arr.backgroundColor.length; i++) {
        const element = arr.backgroundColor[i];
        if (typeof element === "string") {
          arr.backgroundColor[i] = this.gradient_func(element);
        }
      }
    });

    this.renderChart(
      {
        labels: headers,
        datasets: data,
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
      }
    );
  },
  methods: {
    gradient_func(rgb) {
      const color = rgb.split(",");
      color[2] = color[2].slice(0, -1);
      let grad1 = [color[0], color[1], color[2], "1)"].join(",");
      let grad2 = [color[0], color[1], color[2], "0.5)"].join(",");
      let grad3 = [color[0], color[1], color[2], "0.1)"].join(",");
      this.gradient = this.$refs.canvas
        .getContext("2d")
        .createLinearGradient(0, 0, 0, 450);
      this.gradient.addColorStop(0, grad1);
      this.gradient.addColorStop(0.5, grad2);
      this.gradient.addColorStop(1, grad3);
      return this.gradient;
    },
  },
};
</script>
